import { composeUseModal } from "@deliverr/ui-facility";
import { visibleSortationModalsState } from "./SortationModalState";

export const useSortationModal = composeUseModal(visibleSortationModalsState);
